"use strict";
/**
* Cache.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* ECS data cache
*/
Object.defineProperty(exports, "__esModule", { value: true });
var each = require("lodash/each");
var subscribableevent_1 = require("subscribableevent");
var SyncTasks = require("synctasks");
var Models_1 = require("./Models");
var Cache = /** @class */ (function () {
    function Cache(_config) {
        this._config = _config;
        this.configUpdated = new subscribableevent_1.default();
        this._cachedConfigs = {};
        // noop
    }
    Cache.prototype.initialize = function () {
        return this.updateConfigsToFetch();
    };
    Cache.prototype.updateConfigsToFetch = function () {
        var _this = this;
        var _a = this._config.getConfig(), databaseInterface = _a.databaseInterface, configsToFetch = _a.configsToFetch;
        // If we don't have DB support, we can't pre-populate any cache
        if (!databaseInterface) {
            return SyncTasks.Resolved();
        }
        var dbFetchPromises = [];
        each(configsToFetch, function (configType) {
            // If we've already retrieved from the cache, don't fetch again
            if (_this._cachedConfigs[configType]) {
                return;
            }
            dbFetchPromises.push(databaseInterface.getData(configType).then(function (ecsConfig) {
                if (ecsConfig) {
                    _this._cachedConfigs[configType] = ecsConfig;
                }
            }).catch(function () {
                // Return resolved no matter what happens
                return SyncTasks.Resolved();
            }));
        });
        return SyncTasks.all(dbFetchPromises).then(function () {
            // If we fetched 1 or more configs, trigger a change
            if (dbFetchPromises.length > 0) {
                _this.configUpdated.fire();
            }
        });
    };
    Cache.prototype.getEcsConfig = function () {
        // Try user, then fallback to default
        return (this._cachedConfigs[Models_1.EcsConfigType.User] || this._cachedConfigs[Models_1.EcsConfigType.Default]);
    };
    Cache.prototype.getEcsConfigByType = function (configType) {
        return this._cachedConfigs[configType];
    };
    Cache.prototype.putConfig = function (ecsConfig) {
        // Store the config that we used before putting
        var oldEcsConfig = this.getEcsConfig();
        // Store new config
        this._cachedConfigs[ecsConfig.configType] = ecsConfig;
        var currentEcsConfig = this.getEcsConfig();
        // Only notify if the config of the same type changed or we've changed config types
        if (currentEcsConfig && currentEcsConfig.configType === ecsConfig.configType ||
            (oldEcsConfig && currentEcsConfig && oldEcsConfig.configType !== currentEcsConfig.configType)) {
            this.configUpdated.fire();
        }
        var databaseInterface = this._config.getConfig().databaseInterface;
        // If we don't have DB support, we can't pre-populate any cache
        if (!databaseInterface) {
            return SyncTasks.Resolved();
        }
        return databaseInterface.putData(ecsConfig.configType, ecsConfig);
    };
    return Cache;
}());
exports.default = Cache;
